// extracted by mini-css-extract-plugin
module.exports = {"title":"_8c9b1","copy":"_349b0","wrapper":"_57b33","block":"_92b3f","header":"aae8f","info":"_24da7","quote":"d5c25","image":"da7a2","article":"bd966","frame":"b4f14"};